import { FC } from 'react';

import { Text, TextProps } from '@chakra-ui/react';

const FooterListHeader: FC<TextProps> = ({ ...textProps }) => (
    <Text fontWeight="thin" fontSize="xl" mb={2} {...textProps} />
);

export default FooterListHeader;
